import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import PageHeader from "@Shared/components/general/page-header";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MarketingCampaignCriteria from "./marketing-campaign-criteria";
import MaterialInput from "@Shared/components/inputs/material-input";
import Select2 from "@Shared/components/inputs/select2";
import TimeInput from "@Broker/@Modules/automation/automation/components/argument-types/time";
import CreateEmailModal from "@Broker/@Modules/marketing/components/campaigns/create-email-modal";
import MarketingEmailsSelect from "@Broker/@Modules/marketing/components/campaigns/marketing-emails-select";
import { mapActions, mapGetters, mapState } from "vuex";
import { GET_CAMPAIGN, CAMPAIGNS, GET_MARKETING_EMAILS, LISTS } from "../../store/marketing/marketing-getters";
import { CANCEL_CAMPAIGN, CREATE_MARKETING_CAMPAIGN, LOAD_LISTS, LOAD_MARKETING_EMAILS, LOAD_SEGMENT_DATA, LOAD_MARKETING_CAMPAIGNS, UPDATE_CURRENT_CAMPAIGN, UPDATE_CAMPAIGN, LOAD_CURRENT_LIST, RESET_CURRENT_LIST } from "../../store/marketing/marketing-actions";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Err from "@Broker/@Routes/error";
import CreateCampaignModal from "./create-campaign-modal.vue";
import CancelCampaignModal from "./confirm-cancel-campaign-modal.vue";
import { showToast } from "@Shared/@Utils/constants";
import MarketingCampaignDetailsLoader from "./marketing-campaign-details-loader.vue";
import MarketingCampaignTemplateSelect from "./marketing-campaign-template-select.vue";
import { UPDATE_CURRENT_TEMPLATE } from "../../store/templates/templates-actions";
import ListSelectionTemplate from "@Broker/@HandlebarsTemplates/marketing/lists/_list-selection.hbs";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { validDate, futureDate } from "@Shared/@Utils/validation-rules";
import Amplitude from "@Shared/@Utils/amplitude";
import { cloneDeep, isEmpty, isNull, isUndefined } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingCampaignDetails",
  title() {
    return this.$t("sidebar.sections.campaigns");
  },
  components: {
    PageHeader,
    SimpleButton,
    MarketingCampaignCriteria,
    MaterialInput,
    Select2,
    TimeInput,
    CreateEmailModal,
    MarketingEmailsSelect,
    CreateCampaignModal,
    CancelCampaignModal,
    MarketingCampaignDetailsLoader,
    MarketingCampaignTemplateSelect,
    DatepickerInput
  },
  mixins: [validationMixin],
  validations: {
    campaignDetails: {
      name: {
        required
      },
      listId: {
        required
      },
      fromName: {
        required
      },
      email: {
        required
      },
      subject: {
        required
      },
      previewText: {
        required
      },
      scheduledDate: {
        required,
        validDate,
        futureDate
      },
      scheduledTime: {
        required
      },
      templateId: {
        required
      }
    }
  },
  props: {
    campaignId: {
      type: [String, Number],
      default: ""
    },
    withEmptyData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      savingSucceeded: false,
      goAddList: {
        path: "/marketing/lists/add",
        query: {
          fromCampaign: true,
          backPath: `/marketing/campaigns/${this.campaignId}`
        }
      },
      campaignDetails: {
        name: null,
        listId: null,
        segmentId: null,
        fromName: null,
        email: {
          id: null
        },
        subject: null,
        previewText: null,
        scheduledDate: null,
        scheduledTime: null,
        templateId: "",
        templateName: ""
      },
      canceling: false,
      createEmail: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("TemplatesStore", ["currentTemplate"])), mapState("MarketingStore", ["currentList"])), mapGetters("MarketingStore", [GET_CAMPAIGN, CAMPAIGNS, LISTS, GET_MARKETING_EMAILS])), {}, {
    create() {
      return this.campaignId === "add";
    },
    editable() {
      return this.campaignDetails.status === "active" || this.create;
    },
    showTemplate() {
      return !(this.create && isEmpty(this.currentTemplate));
    },
    canSave() {
      return !this.$v.$invalid && this.campaignDetails.email.verified;
    },
    showCancelButton() {
      return !this.create && this.campaignDetails.status === "active";
    },
    segmentDisabled() {
      return !this.editable || isNull(this.campaignDetails.listId) || this.currentList.name === "";
    },
    showVerifyEmail() {
      return !(this.campaignDetails.email.id === null || this.campaignDetails.email.verified) && this.editable;
    }
  }),
  mounted() {
    this.loadData();
    Amplitude.logEvent("Campaigns - details visited");
  },
  beforeDestroy() {
    if (this.campaignId === "add") this.UPDATE_CURRENT_CAMPAIGN(_objectSpread(_objectSpread({}, this.campaignDetails), {}, {
      scheduledDate: this.getFullScheduledDate(),
      campaignId: "add"
    }));
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("MarketingStore", [LOAD_LISTS, LOAD_MARKETING_EMAILS, LOAD_SEGMENT_DATA, CREATE_MARKETING_CAMPAIGN, CANCEL_CAMPAIGN, LOAD_MARKETING_CAMPAIGNS, UPDATE_CURRENT_CAMPAIGN, UPDATE_CAMPAIGN, LOAD_CURRENT_LIST, RESET_CURRENT_LIST])), mapActions("TemplatesStore", [UPDATE_CURRENT_TEMPLATE])), {}, {
    handleEmailChange(selectedEmail) {
      const type = typeof selectedEmail;
      if (isUndefined(selectedEmail)) {
        this.campaignDetails.email = {
          id: null
        };
      } else if (type === "string") {
        var _context;
        this.campaignDetails.email = _objectSpread(_objectSpread({}, _findInstanceProperty(_context = this.GET_MARKETING_EMAILS).call(_context, email => email.emailId === selectedEmail)), {}, {
          id: selectedEmail
        });
      } else {
        this.campaignDetails.email = selectedEmail;
      }
    },
    getFullScheduledDate() {
      return moment(this.campaignDetails.scheduledDate + " " + this.campaignDetails.scheduledTime).toISOString();
    },
    async handleSubmit() {
      try {
        this.saving = true;
        const campaignDetails = _objectSpread(_objectSpread({}, this.campaignDetails), {}, {
          scheduledDate: this.getFullScheduledDate(),
          emailId: _parseInt(this.campaignDetails.email.id),
          listId: _parseInt(this.campaignDetails.listId)
        });
        if (this.create) {
          await this.CREATE_MARKETING_CAMPAIGN(campaignDetails);
        } else {
          await this.UPDATE_CAMPAIGN(campaignDetails);
        }
        this.savingSucceeded = true;
        showToast("success", this.create ? "campaignCreated" : "campaignSaved");
        this.goToCampaigns();
      } catch (e) {
        Err.handle(e);
        this.savingSucceeded = false;
      } finally {
        this.saving = false;
      }
    },
    async loadData() {
      var _campaign$email$id, _campaign$email;
      this.loading = true;
      const loadActions = [this.LOAD_LISTS(), this.LOAD_MARKETING_EMAILS()];
      if (this.withEmptyData) this.resetData();
      if (!this.CAMPAIGNS.length) await this.LOAD_MARKETING_CAMPAIGNS({
        all: true
      });
      const campaign = this.GET_CAMPAIGN(this.campaignId);
      this.campaignDetails = _objectSpread(_objectSpread(_objectSpread({}, this.campaignDetails), campaign), {}, {
        scheduledDate: moment(campaign.scheduledDate).format("YYYY-MM-DD"),
        scheduledTime: moment(campaign.scheduledDate).format("HH:mm:ss")
      });
      const thisCurrentTemplate = this.currentTemplate;
      if (this.create && !isEmpty(thisCurrentTemplate)) {
        this.campaignDetails.templateId = thisCurrentTemplate.templateId;
        this.campaignDetails.templateName = thisCurrentTemplate.templateName;
        this.campaignDetails.templateThumbnail = thisCurrentTemplate.templateThumbnail;
      }
      this.handleEmailChange((_campaign$email$id = (_campaign$email = campaign.email) == null ? void 0 : _campaign$email.id) != null ? _campaign$email$id : campaign.emailId);
      if (this.campaignDetails.listId) loadActions.push(this.LOAD_CURRENT_LIST({
        listId: this.campaignDetails.listId
      }));
      await _Promise.all(loadActions);
      this.loading = false;
    },
    select2Options(type) {
      const options = {
        placeholder: "",
        allowClear: false
      };
      switch (type) {
        case "segment":
          options.placeholder = this.$tc("global.actions.searchA", 1, {
            item: this.$tc("lists.segment", 1).toLowerCase()
          });
          break;
        case "email":
          options.placeholder = this.$tc("global.actions.searchA", 2, {
            item: this.$tc("global.words.email", 1)
          });
          break;
        default:
          options.templateResult = state => $(ListSelectionTemplate(_objectSpread(_objectSpread({}, state), {}, {
            emailText: this.$tc("global.words.email", state.emailCount)
          })));
          options.placeholder = this.$t("campaigns.actions.searchAList");
      }
      return options;
    },
    showAddEmailModal(createEmail) {
      this.createEmail = createEmail;
      this.$refs.addEmailModal.handleShow();
    },
    showCreateCampaignModal() {
      this.$refs.createCampaignModal.showModal();
    },
    showCancelCampaignModal() {
      this.$refs.cancelCampaignModal.showModal();
    },
    formatData(data) {
      var _data$map, _data;
      data = cloneDeep(data);
      return (_data$map = (_data = data) == null ? void 0 : _mapInstanceProperty(_data).call(_data, ref => {
        var _ref$listId, _ref$listId2;
        ref.id = (_ref$listId = ref.listId) != null ? _ref$listId : ref.id;
        ref.value = (_ref$listId2 = ref.listId) != null ? _ref$listId2 : ref.id;
        ref.text = ref.name;
        return ref;
      })) != null ? _data$map : [];
    },
    resetData() {
      this.UPDATE_CURRENT_TEMPLATE({});
      this.UPDATE_CURRENT_CAMPAIGN({
        campaignId: "add"
      });
      this.RESET_CURRENT_LIST();
    },
    goToCampaigns() {
      this.$router.replace({
        name: "marketing-campaigns"
      });
    },
    async handleCancel() {
      try {
        this.canceling = true;
        await this.CANCEL_CAMPAIGN(this.campaignDetails);
        showToast("success", "campaignCancelled");
        this.goToCampaigns();
      } catch (e) {
        Err.handle(e);
      } finally {
        this.canceling = false;
      }
    },
    async handleListChange(item) {
      this.campaignDetails.listId = item.id;
      this.campaignDetails.segmentId = null;
      await this.LOAD_CURRENT_LIST({
        listId: this.campaignDetails.listId
      });
    }
  })
});